import { useMutation, useQueryClient } from "@tanstack/react-query";

import { logger } from "#app/monitoring/Logger";
import { CreateProcessStep } from "#modules/processSteps/infra/createProcessStep.api";
import { fetchAddPricedProcessStep } from "#modules/quoteRequestLines/infra/fetchAddPricedProcessStep.api";
import { quoteRequestLineQuery } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";

export const useAddPricedProcessStep = (options?: {
  onSuccess?: (processStep: CreateProcessStep) => void;
}) => {
  const queryClient = useQueryClient();

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: fetchAddPricedProcessStep,

    onSuccess: (processStep) => {
      options?.onSuccess?.(processStep);

      if (processStep.quoteRequestLineId) {
        void queryClient.invalidateQueries(
          quoteRequestLineQuery({ id: processStep.quoteRequestLineId }),
        );
      }
    },
    onError: (error) => {
      logger.error(error);
    },
  });

  return { addPricedProcessStep: mutateAsync, ...rest };
};
